import React, { useEffect, useState } from "react";
import { BadgeIndianRupee, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { tx } from "../lib/miniI18n";

/* Small dismissable banner after the master admin changes the rate card (config.rate_notice, 7 days). */
export const RateNoticeBanner = ({ notice, ta }) => {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(true);
  useEffect(() => { setHidden(!notice || localStorage.getItem("rl_rate_notice_seen") === notice.at); }, [notice?.at]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!notice || hidden) return null;
  const when = new Date(notice.at).toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
  return (
    <div className="rounded-xl bg-blue-50 border border-blue-200 px-3 py-2 text-[11px] text-blue-900 flex items-start gap-2" data-testid="rate-notice-banner">
      <BadgeIndianRupee className="w-3.5 h-3.5 shrink-0 mt-0.5" />
      <button onClick={() => navigate("/rate-card")} className="flex-1 text-left">
        <b>{ta ? `Rate card மாற்றம் (${when})` : `${tx("Rate card updated")} (${when})`}:</b> {notice.text}. <span className="underline">{ta ? "முழு rate card" : tx("See full rate card")}</span>
      </button>
      <button onClick={() => { localStorage.setItem("rl_rate_notice_seen", notice.at); setHidden(true); }} className="p-0.5" aria-label="dismiss" data-testid="rate-notice-dismiss"><X className="w-3.5 h-3.5" /></button>
    </div>
  );
};
